// 获取元素
function getElement(id) {
    return document.getElementById(id);
}

// 获取元素的样式属性值
function getStyle(element, styleName) {
    if (window.getComputedStyle) {
        return window.getComputedStyle(element, null)[styleName];
    } else {
        return element.currentStyle[styleName];
    }
}

// 事件监听器绑定
function addEvent(element, eventName, fn) {
    if (element.addEventListener) {
        element.addEventListener(eventName, fn, false);
    } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, fn);
    }
}

// 阻止默认事件
function preventDefault(event) {
    if (event.preventDefault) {
        event.preventDefault();
        event.stopPropagation();
    } else {
        event.returnValue = false;
    }
}

// 初始化拖拽
function initDrag(id) {
    var dragDom = getElement(id);
    var dragImg = dragDom.getElementsByTagName('img')[0];
    var dragging = false;
    var mousePos, mousePosX, mousePosY;

    addEvent(dragDom, 'mousedown', function(event) {
        dragging = true;
        preventDefault(event);
        event.preventDefault();
        mousePos = getStyle(dragDom, 'position');
        mousePosX = event.clientX - parseInt(getStyle(dragDom, 'left'));
        mousePosY = event.clientY - parseInt(getStyle(dragDom, 'top'));
    });

    addEvent(document, 'mousemove', function(event) {
        if (dragging) {
            preventDefault(event);
            dragDom.style.pointerEvents = 'none';
            dragDom.style.position = 'fixed';
            dragDom.style.left = (event.clientX - mousePosX) + 'px';
            dragDom.style.top = (event.clientY - mousePosY) + 'px';
        }
    });

    addEvent(document, 'mouseup', function(event) {
        dragging = false;
        // 避免click事件触发
        dragDom.style.pointerEvents = null;
    });
}

export { initDrag };
